var map = {
	"./site-logo-desktop-footer.svg": 83033,
	"./site-logo-desktop.svg": 50575,
	"./site-logo-mobile-drawer.svg": 33339,
	"./site-logo-mobile.svg": 57291,
	"./site-logo-sm.svg": 38505,
	"./site-logo-tv.svg": 35295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92140;